/* eslint-disable import/no-cycle */
import LocalStorageService from '@/services/LocalStorageService';
import LocalizationService from '@/services/LocalizationService';
import { DEFAULT_LANGUAGE } from '@/types/consts';
import NativeService from './NativeService';
import FromFlutterService from './FromFlutterService';

export default class InitService {
  private static setLanguage(value) {
    LocalStorageService.setLanguage(value);
    LocalizationService.fetchAndStoreMessages();
  }

  public static init(): void {
    if (LocalStorageService.getLanguage() === null) {
      LocalStorageService.setLanguage(DEFAULT_LANGUAGE.key);
    }
    LocalizationService.fetchAndStoreMessages();

    // eslint-disable-next-line dot-notation
    window['nativeService'] = {
      onSleep: NativeService.onSleep,
      onAwake: NativeService.onAwake,
      setToken: NativeService.setToken,
      setPhotoLibStatus: NativeService.setPhotoLibStatus,
      gotoPage: NativeService.gotoPage,
      setIconBadge: NativeService.setIconBadge,
    };

    // eslint-disable-next-line dot-notation
    window['fromFlutter'] = {
      closeImagePicker: FromFlutterService.closeImagePicker,
      closeFilePicker: FromFlutterService.closeFilePicker,
      closeCamera: FromFlutterService.closeCamera,
    };

    // eslint-disable-next-line dot-notation
    window['localizationService'] = {
      setLanguage: this.setLanguage,
    };
  }
}
